import { z } from "zod";

/**
 * The typed contract between the AI gateway and the frontend chart renderer.
 * The model emits this JSON; the client renders it with @causetide/ui charts.
 * The model never emits HTML or JS.
 */
export const zChartSeries = z.object({
  key: z.string(),
  label: z.string(),
  color: z.enum(["accent", "chart-1", "chart-2", "chart-3", "chart-4", "chart-5"]).default("accent"),
});

export const zChartSpec = z.object({
  version: z.literal(1),
  kind: z.enum(["area", "bar", "line", "pie", "funnel", "metric", "table"]),
  title: z.string().max(200),
  subtitle: z.string().max(300).optional(),
  xKey: z.string().optional(),
  series: z.array(zChartSeries).max(6).default([]),
  stacked: z.boolean().default(false),
  valueFormat: z.enum(["number", "currency", "percent"]).default("number"),
  data: z.array(z.record(z.union([z.string(), z.number(), z.null()]))).max(1000),
  columns: z
    .array(z.object({ key: z.string(), label: z.string(), format: z.enum(["text", "number", "currency", "percent", "date"]).default("text") }))
    .optional()
    .describe("for kind=table"),
});
export type ChartSpec = z.infer<typeof zChartSpec>;
